import {
  NameSpecifiedEntity
} from "../entity";

export class DocumentKind extends NameSpecifiedEntity<string> {
  constructor(id: string, name: string) {
    super(id, name);
  }

  static areEqual(source: DocumentKind, destination: DocumentKind): boolean {
    return (source === destination)
      || (source && destination && (source.id === destination.id));
  }
}
